/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.filtersModule')

/**
* An Angular filter which sets the seconds into a Date object.
*/
  .filter('secondsToDate', ['$translate', ($translate) => {
    function secondsToDate(seconds) {
      if (seconds < 0) {
        return $translate.instant('organization_archive_seconds_calculating');
      }

      return new Date(1970, 0, 1).setSeconds(seconds);
    }

    return secondsToDate;
  }]);
